<button
  class="info-button"
  type="button"
  (click)="toggle()"
  (clickOutside)="close()"
  aria-label="Show description">
  i
</button>

<div class="popup" *ngIf="isOpen">
  <div class="popup-content">
    <div class="popup-row">
      <ng-content></ng-content>
    </div>
  </div>
  <a (click)="close()" class="popup-close">x</a>
</div>
